export default function Hero() {
  const stats = [
    { id: "s1", value: "12+", label: "正版观看平台" },
    { id: "s2", value: "40+", label: "精选片单条目" },
    { id: "s3", value: "2", label: "日语 / 韩语分区" },
    { id: "s4", value: "4", label: "常见字幕类型" },
  ];

  const picks = [
    {
      id: "p1",
      title: "请回答1988",
      meta: "韩剧 · 家庭 / 青春",
      cover:
        "https://readdy.ai/api/search-image?query=warm%20retro%20movie%20poster%20style%20cover%20showing%20a%20sunlit%20old%20seoul%20alley%20with%20bicycles%20and%20hanging%20laundry%2C%20amber%20and%20terracotta%20color%20grade%2C%20soft%20film%20grain%2C%20minimal%20elegant%20composition%2C%20no%20text&width=600&height=900&seq=guide-cover-01&orientation=portrait",
    },
    {
      id: "p2",
      title: "重启人生",
      meta: "日剧 · 奇幻 / 剧情",
      cover:
        "https://readdy.ai/api/search-image?query=warm%20minimal%20movie%20poster%20style%20cover%20showing%20a%20quiet%20japanese%20suburban%20street%20at%20golden%20hour%20with%20a%20lone%20streetlight%2C%20amber%20and%20moss%20green%20color%20grade%2C%20soft%20film%20grain%2C%20elegant%20negative%20space%2C%20no%20text&width=600&height=900&seq=guide-cover-02&orientation=portrait",
    },
    {
      id: "p3",
      title: "寄生虫",
      meta: "韩影 · 剧情 / 悬疑",
      cover:
        "https://readdy.ai/api/search-image?query=dramatic%20minimal%20movie%20poster%20style%20cover%20showing%20a%20narrow%20basement%20window%20with%20warm%20light%20piercing%20through%20dust%2C%20amber%20and%20deep%20charcoal%20color%20grade%2C%20soft%20film%20grain%2C%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=guide-cover-03&orientation=portrait",
    },
    {
      id: "p4",
      title: "海街日记",
      meta: "日影 · 家庭 / 治愈",
      cover:
        "https://readdy.ai/api/search-image?query=gentle%20movie%20poster%20style%20cover%20showing%20a%20seaside%20japanese%20town%20with%20cherry%20blossoms%20and%20blue%20skies%20reflected%20in%20water%2C%20soft%20warm%20and%20green%20color%20grade%2C%20film%20grain%2C%20serene%20composition%2C%20no%20text&width=600&height=900&seq=guide-cover-04&orientation=portrait",
    },
  ];

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section className="relative w-full min-h-[92vh] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=cinematic%20warm%20abstract%20background%20inspired%20by%20japanese%20and%20korean%20film%20aesthetics%2C%20soft%20amber%20and%20moss%20green%20gradients%2C%20subtle%20film%20grain%20texture%2C%20blurred%20bokeh%20city%20lights%2C%20moody%20elegant%20editorial%20mood%2C%20high%20detail&width=1920&height=1080&seq=guide-hero-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/65"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 pt-28 pb-16 md:pt-32 md:pb-20">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs md:text-sm font-medium">
            <i className="ri-movie-line"></i>
            中文观影指南 · 正版优先
          </span>
          <h1 className="mt-5 font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight">
            日韩中文字幕
            <span className="block text-primary-300 mt-1">到底去哪里看才靠谱</span>
          </h1>
          <p className="mt-5 text-sm md:text-base text-background-100/90 leading-relaxed max-w-2xl">
            这里不是资源下载站，而是一份观影指南：把有中文字幕的日韩剧集与电影、常用正版平台、字幕类型和选片方法整理在一页里，帮你少走弯路、看得安心。内容覆盖平台对比、语种分区片单与常见问题解答。
          </p>

          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <button
              onClick={() => scrollTo("platforms")}
              className="px-6 py-3 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              查看观看平台
            </button>
            <button
              onClick={() => scrollTo("titles")}
              className="px-6 py-3 rounded-md bg-white/10 hover:bg-white/20 text-background-50 text-sm font-medium border border-white/25 transition-colors cursor-pointer whitespace-nowrap"
            >
              浏览分类片单
            </button>
          </div>

          <dl className="mt-9 grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-2xl">
            {stats.map((s) => (
              <div key={s.id} className="border-l-2 border-primary-400/70 pl-3">
                <dt className="text-2xl md:text-3xl font-heading font-semibold text-background-50">
                  {s.value}
                </dt>
                <dd className="text-xs md:text-sm text-background-100/80 mt-1">{s.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {picks.map((p) => (
            <div
              key={p.id}
              className="group flex items-center gap-3 rounded-lg bg-white/10 backdrop-blur border border-white/15 p-2.5 md:p-3 hover:bg-white/20 transition-colors"
            >
              <div className="w-14 h-20 md:w-16 md:h-24 rounded-md overflow-hidden shrink-0 bg-background-900">
                <img
                  src={p.cover}
                  alt={`${p.title} 封面`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="min-w-0">
                <p className="text-sm md:text-base font-medium text-background-50 truncate">
                  {p.title}
                </p>
                <p className="text-[11px] md:text-xs text-background-100/75 mt-1 line-clamp-2">
                  {p.meta}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}